import { SupportDetailAdminCheckTransferContainer } from "../../containers/SupportSystem/Admin/SupportDetailAdminCheckTransferContainer";
export function SupportDetailAdminCheckTransferPage () {
    return(
       <SupportDetailAdminCheckTransferContainer/>
    )
}